import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LazyImage from 'appSrc/components/Lazy/Image';
import { convertImage } from 'appSrc/utils/random';
import AspectRatio from 'react-aspect-ratio';
import TextTruncate from 'react-text-truncate';
import { Popup } from 'semantic-ui-react';
import style from './styles/style.module.css';


class ProductCarouselCard extends PureComponent {
    render() {
        const { product } = this.props;

        return this.popupWrapper(
            <div className={ `${ style.productShopCard } ${ this.props.className }` }
            style={ { ...this.props.style } }>
                <div className={ style.cardContent }>
                    <Link to={ '/app/products/' + product.desireid + '/' + encodeForURI(product.title) }
                    className={ style.linkOverlay }></Link>

                    <Link to={ '/app/products/' + product.desireid + '/' + encodeForURI(product.title) }
                    className={ style.productImage }>
                        <AspectRatio ratio='1/1'>
                            <div className={ style.imageWrapper } >
                                { this.props.carousel ?
                                    <img src={ convertImage( product.image, '/276x276' ) } alt='product image' />
                                    :
                                    <LazyImage source={ convertImage( product.image, '/276x276' ) } />
                                }
                            </div>
                        </AspectRatio>
                    </Link>
                    <div className={ style.expandedCard }>
                        <div className={ style.associatedDetails }>
                            <TextTruncate className={ `${ style.detail } ${ style.productTitle }` }
                            line={ 2 }
                            text={ product.title } />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    popupWrapper = ( triggerContent ) => {
        const { product } = this.props;

        return (
            <Popup className={ style.productPopup } key={ product.desireid }
            position='bottom center'
            inverted
            trigger={ triggerContent }>
                <Popup.Content className={ style.popupContent }>
                    <TextTruncate
                    line={ 4 }
                    text={ product.description } />
                    <p className={ style.price }>${ product.price }</p>
                </Popup.Content>
            </Popup>
        );
    }
}
ProductCarouselCard.defaultProps = {
    product: {},
    className: '',
};
ProductCarouselCard.propTypes = {
    product: PropTypes.object.isRequired,
};

export default ProductCarouselCard;
